module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0005_06_A18_Final.2eca188.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0005_06_A18_Final.jpg
// module id = QnQA
// module chunks = 0